import { formatApiDateRangeDisplay } from '#/utils/date';

export function readMiscPurchaseOrderDateRangeFilter(filters = {}) {
  const from = filters.purchaseOrderDateFrom;
  const to = filters.purchaseOrderDateTo;

  if (!from && !to) {
    return undefined;
  }

  return {
    from: from ?? '',
    to: to ?? from ?? '',
  };
}

export function applyMiscPurchaseOrderDateRangeToFilters(filters = {}, range) {
  const next = { ...filters };

  if (!range?.from && !range?.to) {
    delete next.purchaseOrderDateFrom;
    delete next.purchaseOrderDateTo;
    return next;
  }

  const from = range.from || range.to;
  const to = range.to || range.from;
  next.purchaseOrderDateFrom = from || undefined;
  next.purchaseOrderDateTo = to || undefined;
  return next;
}

export function resolveMiscPurchaseOrderDateFilterChipDisplay(values = []) {
  return values.map((value) => formatApiDateRangeDisplay(value) || value);
}
